import { gql } from '@/core/shared/api';
import { once } from 'lodash-es';
import { ref } from '@vue/composition-api';
import { useLoading } from '@/core/shared/composition-helpers';

const useLanguages = once(function useLanguages () {
  const { subscribeToPromise, loading } = useLoading();
  const languages = ref(null);
  (async function () {
    const promise = gql.request(`query {
      languages {
        key
        title
      }
    }`);
    subscribeToPromise(promise);
    const { languages: allLanguages } = await promise;
    languages.value = allLanguages;
  })();
  return {
    loading,
    languages,
  };
});
export default useLanguages;
